import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';

var ConfiguratorMain = (_param)=>{
    var { className , currentStepName , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "currentStepName",
        "children"
    ]);
    const mainRef = /*#__PURE__*/ React.createRef();
    const isPhone = MediaQuery.useIsPhone();
    React.useLayoutEffect(()=>{
        var ref;
        if (!isPhone) {
            return;
        }
        mainRef === null || mainRef === void 0 ? void 0 : (ref = mainRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        currentStepName
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: mainRef,
        "data-t": rest['data-t'],
        className: className
    }, children);
};

export { ConfiguratorMain };
//# sourceMappingURL=ConfiguratorMain.js.map
